
import React from 'react'

const ResultadoDetailTablaPuestos = (props) => {
  const resultado = props.resultado

  // console.info(props)
  if (props.controlList) {
    return <div className={'resultado__tabla-container'}>
      <table className={'resultado__tabla'}>
        <thead>
          <tr>
            <th className={'text-left'}>
              Control
            </th>
            <th className={'text-right'}>
              Puesto
            </th>
            <th className={'text-right'}>
              Género
            </th>
            <th className={'text-right'}>
              Categoría
            </th>
          </tr>
        </thead>
        <tbody>
          {props.controlList.map((control) => {
            const puesto = resultado[ 'control_' + control.id + '_puesto' ]
            const puestoSexo = resultado[ 'control_' + control.id + '_puesto_' + resultado['sexo'] ]
            const puestoCategoria = resultado[ 'control_' + control.id + '_puesto_categoria' ]

            return <tr key={control.id}>
              <td>
                {control.nombre}<br /><span className={'small-text'}>{control.descripcion}</span>
              </td>
              <td className={'text-right '}>
                {puesto || '---'}
              </td>
              <td className={'text-right'}>
                {puestoSexo || '---'}
              </td>
              <td className={'text-right'}>
                {puestoCategoria || '---'}
              </td>
            </tr>
          })}
        </tbody>
      </table>
    </div>
  } else {
    return <div />
  }
}

export default ResultadoDetailTablaPuestos



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailTablaPuestos.js